import { createLocale } from '../../utils.js';

import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';

export default {
  en: createLocale(en, 'measurementUnits'),
  uk: createLocale(uk, 'measurementUnits'),
  pl: createLocale(pl, 'measurementUnits'),
  ru: createLocale(ru, 'measurementUnits'),
  es: createLocale(es, 'measurementUnits'),
  uz: createLocale(uz, 'measurementUnits'),
  hi: createLocale(hi, 'measurementUnits'),
};
